import { extendTheme } from '@chakra-ui/react';

// Definir breakpoints personalizados
const breakpoints = {
	base: '0px', // móvil pequeño
	sm: '320px', // móvil
	md: '768px', // tablet
	lg: '1024px', // desktop pequeño
	xl: '1280px', // desktop
	'2xl': '1536px', // desktop grande
};

// Configuración global responsive
const config = {
	initialColorMode: 'light',
	useSystemColorMode: false,
};

// Estilos globales responsive
const styles = {
	global: {
		'html, body': {
			height: '100%',
		},
		body: {
			fontSize: { base: '14px', md: '16px' },
			overflowX: 'hidden',
			width: '100%',
		},
		'#root': {
			minHeight: '100vh',
			width: '100%',
		},
		// Imágenes responsive
		img: {
			maxWidth: '100%',
			height: 'auto',
		},
		// Tablas responsive
		'.chakra-table__container': {
			overflowX: 'auto',
			WebkitOverflowScrolling: 'touch',
		},
		// Cards y contenedores
		'.chakra-card': {
			maxWidth: '100%',
		},
		// Formularios
		'input, textarea, select, button': {
			maxWidth: '100%',
		},
	},
};

// Componentes con defaults responsive
const components = {
	Container: {
		baseStyle: {
			maxW: {
				base: '100%',
				sm: '640px',
				md: '768px',
				lg: '1024px',
				xl: '1280px',
			},
		},
	},
	Button: {
		baseStyle: {
			fontSize: { base: 'sm', md: 'md' },
		},
	},
	Heading: {
		baseStyle: {
			fontSize: {
				base: 'lg',
				md: 'xl',
				lg: '2xl',
			},
		},
	},
	Table: {
		baseStyle: {
			fontSize: { base: 'xs', md: 'sm' },
		},
	},
	Modal: {
		baseStyle: {
			dialog: {
				maxW: {
					base: '95vw',
					md: 'auto',
				},
				mx: { base: 2, md: 'auto' },
			},
		},
	},
};

const theme = extendTheme({
	breakpoints,
	config,
	styles,
	components,
});

export default theme;
